import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { UserContext } from '../../context/UserContext';
import { usersApi, authApi } from '../../api';
import '../../css/components/UserCard.css';
import HrnbCard from "../controls/HrnbCard";
import { HrnbListGroup, HrnbListGroupItem } from "../controls/HrnbListGroup";
import HrnbLabel from "../controls/HrnbLabel";
import HrnbFormControl from "../controls/HrnbFormControl";
import HrnbButton from "../controls/HrnbButton";
import { SaveIcon } from "../../icons";

export default function UserCard({ user }) {
    const [editedUser, setEditUser] = useState({...user});
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const {setCurrentUser} = useContext(UserContext);
    const [saving, setSaving] = useState(false);
    const [updatingPassword, setUpdatingPassword] = useState(false);

    const handleSaveChanges = async () => {
        setSaving(true);
        try {
            const requestBody = {
                username: editedUser.username,
                email: editedUser.email
            };
            const updated = await usersApi.update(editedUser.id, requestBody);
            setCurrentUser && setCurrentUser(updated);
            setEditUser(prev => ({...prev, ...updated}));
        } catch (err) {
            console.error('Error: ', err);
        } finally {
            setSaving(false);
        }
    };

    const handleUpdatePassword = async () => {
        setPasswordError("");
        if (!newPassword) {
            setPasswordError("Введите пароль");
            return;
        }
        if (newPassword !== confirmPassword) {
            setPasswordError("Пароли не совпадают");
            return;
        }
        setUpdatingPassword(true);
        try {
            await authApi.updatePassword(newPassword, confirmPassword);
            setNewPassword("");
            setConfirmPassword("");
        } catch (err) {
            setPasswordError(err?.response?.data?.message || err?.message || 'Ошибка обновления пароля');
            console.error('Error: ', err);
        } finally {
            setUpdatingPassword(false);
        }
    };

    return (
        <HrnbCard className="user-card">
            <div className="hrnb-card__title">Информация о пользователе: {editedUser.id}</div>
            <HrnbListGroup>
                <HrnbListGroupItem>
                    <HrnbLabel text="Имя:">
                        <HrnbFormControl
                            type="text"
                            value={editedUser.username || ''}
                            onChange={e => setEditUser(prev => ({...prev, username: e.target.value}))}
                        />
                    </HrnbLabel>
                </HrnbListGroupItem>

                <HrnbListGroupItem>
                    <HrnbLabel text="Email:">
                        <HrnbFormControl
                            type="email"
                            value={editedUser.email || ''}
                            onChange={e => setEditUser(prev => ({...prev, email: e.target.value}))}
                        />
                    </HrnbLabel>
                </HrnbListGroupItem>

                <HrnbListGroupItem>
                    <HrnbLabel text="Новый пароль:">
                        <HrnbFormControl
                            type="password"
                            value={newPassword}
                            onChange={e => setNewPassword(e.target.value)}
                        />
                    </HrnbLabel>
                    <HrnbLabel text="Подтверждение пароля:" style={{marginTop: '12px'}}>
                        <HrnbFormControl
                            type="password"
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                        />
                    </HrnbLabel>
                    {passwordError && <div style={{ color: 'red', marginTop: 8 }}>{passwordError}</div>}
                    <HrnbButton color="warning" onClick={handleUpdatePassword} style={{marginTop: '20px'}}
                                disabled={updatingPassword || !newPassword || !confirmPassword}>
                        {updatingPassword ? 'Обновление...' : 'Сменить пароль'}
                    </HrnbButton>
                </HrnbListGroupItem>

                <HrnbListGroupItem>
                    <strong>Роль:</strong> {user.role}
                </HrnbListGroupItem>

                <HrnbListGroupItem>
                    <strong>Активность:</strong> {user.isActive ? 'Активен' : 'Заблокирован'}
                </HrnbListGroupItem>

                <HrnbListGroupItem>
                    <strong>Зарегистрирован:</strong> {user.createdAt ? new Date(user.createdAt).toLocaleString() : '-'}
                </HrnbListGroupItem>

                <HrnbListGroupItem>
                    <strong>Последнее
                        изменение:</strong> {user.updatedAt ? new Date(user.updatedAt).toLocaleString() : '-'}
                </HrnbListGroupItem>
            </HrnbListGroup>

            <div style={{display: "flex", gap: 12, marginTop: 18}}>
                <HrnbButton color="primary" onClick={handleSaveChanges} icon={<SaveIcon/>} disabled={saving}>
                    {saving ? 'Сохранение...' : 'Сохранить изменения'}
                </HrnbButton>
            </div>
        </HrnbCard>
    );
}
UserCard.propTypes = {
    user: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        username: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        role: PropTypes.string,
        isActive: PropTypes.bool,
        createdAt: PropTypes.string,
        updatedAt: PropTypes.string,
        profiles: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                displayName: PropTypes.string,
                avatar: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            })
        ),
    }).isRequired,
};
